/**
 * /onboarding/$token/submitted — holding-pattern page (T-034).
 *
 * PRD-003 PR-06, PR-07, US-04, US-05. After submit, the subscriber lands here
 * and can take no further action until Eric reviews. There is intentionally NO
 * CTA to /portal: the next move is Eric's, and the page says so plainly.
 *
 * Locked copy (T-034 AC + content-pages.md line 117 + design-guidelines.md
 * §"Onboarding submitted holding page"). The backlog AC is the authoritative
 * wording and uses a comma (no em dash) — that is what ships (GEN-07; the
 * design-guidelines variant with a dash is the older form and is not used):
 *
 *   "Got it. Eric is reading your context now. You'll hear from him within a
 *    day, and you'll know it when you do."
 *
 * No data write, no entry guard beyond the route existing. A subscriber who
 * bookmarks this URL just sees the holding copy; the welcome view arrives in
 * /portal once Eric marks reviewed (Phase G T-038), not here.
 */

import { createFileRoute } from '@tanstack/react-router';
import { OnboardingLayout } from '@/components/onboarding/OnboardingLayout';

export const Route = createFileRoute('/onboarding/$token/submitted')({
  component: OnboardingSubmitted,
});

function OnboardingSubmitted() {
  return (
    <OnboardingLayout>
      <section className="py-6 text-center sm:py-10">
        <p className="text-xs font-medium uppercase tracking-wide text-[color:var(--color-text-mute)]">
          Sent
        </p>
        <p className="mt-4 font-display text-2xl leading-relaxed text-[color:var(--color-navy)] sm:text-3xl">
          Got it. Eric is reading your context now. You&apos;ll hear from him
          within a day, and you&apos;ll know it when you do.
        </p>
      </section>
    </OnboardingLayout>
  );
}
